export const LOADING_DISCIPLINARY_ACTION = "LOADING_DISCIPLINARY_ACTION";
export const SAVE_LOADING_DISCIPLINARY_ACTION = "SAVE_LOADING_DISCIPLINARY_ACTION";
export const GET_DISCIPLINARY_ACTION = "GET_DISCIPLINARY_ACTION";
export const FORM_FAIL = "FORM_FAIL";
export const DISCIPLINARY_ACTION_FAIL = "DISCIPLINARY_ACTION_FAIL";

